<div class="display-flex flex-column full-height">
  <app-jumbotron class="mb-10">
    <div class="container page-help display-flex gap-1-rem">
      <div class="flex-grow">
        {{ 'metrics.source_metrics_info' | translate }}
      </div>
      <app-help-button template="source-metrics"></app-help-button>
    </div>
  </app-jumbotron>
  <app-jumbotron class="flex-grow">
    <app-metrics-source-table></app-metrics-source-table>
  </app-jumbotron>
</div>
